import React from "react";
import "./AQWpackages.css";
import { createIcons, icons } from "lucide";

const CaseStudiesComponent: React.FC = () => {
    
    const aqw_biomass = "./images/CVreport_biomass.png";
    const { useState, useEffect } = React;

    useEffect(() => {
        // Initialize icons, replacing data-lucide tags
        createIcons({ icons });
    }, []);

    
  return (
    <section id="features" style={{ padding: "72px 24px" }}>
    <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: 48 }}>
        <p
            style={{
            fontSize: 12,
            fontWeight: 600,
            letterSpacing: "0.12em",
            textTransform: "uppercase",
            color: "var(--accent)",
            margin: "0 0 10px"
            }}
        >
            CASE STUDIES
        </p>
        <h2
            style={{
            fontSize: "clamp(28px, 4vw, 44px)",
            margin: "0 0 14px",
            fontWeight: 400
            }}
        >
            Real results from real farmers
        </h2>
        <p style={{ color: "var(--muted)", fontSize: 16, margin: 0 }}>
            See how farms like yours are thriving with our platform.
        </p>
        </div>
        <div
        style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
            gap: 28
        }}
        >
        <div
            className="plan-card featured"
            style={{
            padding: 0,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden"
            }}
        >
            <div
            style={{
                width: "100%",
                height: 120,
                background: "linear-gradient(135deg, #9ED3CD 0%, #5fa399 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                overflow: "hidden"
            }}            
            >
            <i
                data-lucide="book-open-text"
                style={{
                width: 80,
                height: 80,
                color: "rgba(255,255,255,0.9)",
                position: "relative",
                zIndex: 1
                }}
            />
            <div
                style={{
                position: "absolute",
                inset: 0,
                background:
                    "radial-gradient(circle at 30% 30%, rgba(255,255,255,0.15) 0%, transparent 60%)"
                }}
            />
            </div>
            <div
            style={{
                padding: 32,
                display: "flex",
                flexDirection: "column",
                flex: 1
            }}
            >
            <div
                style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                marginBottom: 6
                }}
            >
                <div
                style={{
                    width: 44,
                    height: 44,
                    borderRadius: 10,
                    background: "rgba(158,211,205,0.15)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}
                >
                <i
                    data-lucide="graduation-cap"
                    style={{ width: 22, height: 22, color: "#9ED3CD" }}
                />
                </div>
                <div>
                <p
                    style={{
                    margin: 0,
                    fontSize: 12,
                    color: "#9ED3CD",
                    fontWeight: 600,
                    textTransform: "uppercase",
                    letterSpacing: "0.08em"
                    }}
                >
                    Water Chemistry
                </p>
                <p style={{ margin: 0, fontSize: 13, color: "var(--muted)" }}>
                    Reanalysis
                </p>
                </div>
            </div>
            <h3
                className="serif"
                style={{
                fontSize: 22,
                fontWeight: 400,
                margin: "0 0 12px",
                lineHeight: "1.3",
                color: "var(--text)"
                }}
            >
                Hidden Sulfide Dynamics in Recirculating Aquaculture
            </h3>
            <p
                style={{
                color: "var(--muted)",
                fontSize: 14,
                textAlign: "left", 
                lineHeight: "1.7",
                margin: "0 0 20px"
                }}
            >
                Hydrogen sulfide (H2S) is a critical risk factor in recirculating aquaculture 
                systems (RAS), yet its short-term dynamics and coupling to biological
                activity remain poorly resolved. In this study, we use continuous, high-
                resolution (sub-μg/L) monitoring in a 4700 m3 Atlantic salmon production
                system (∼112 t biomass) to characterize trace H2S behavior over operational
                timescales
            </p>
            <div
                style={{
                borderTop: "1px solid rgba(79,142,247,0.2)",
                paddingTop: 16,
                marginTop: "auto"
                }}
            >
                <div style={{ display: "flex", gap: 12 }}>
                <div>
                    <p
                    style={{
                        margin: 0,
                        fontSize: 12,
                        color: "var(--muted)",
                        textTransform: "uppercase",
                        fontWeight: 600,
                        letterSpacing: "0.08em"
                    }}
                    >
                    Scope
                    </p>
                    <p
                    style={{
                        margin: "4px 0 0",
                        fontSize: 13,
                        color: "var(--text)"
                    }}
                    >
                    Water Quality
                    </p>
                </div>
                <div
                    style={{
                    borderLeft: "1px solid rgba(255,255,255,0.1)",
                    paddingLeft: 12
                    }}
                >
                    <p
                    style={{
                        margin: 0,
                        fontSize: 12,
                        color: "var(--muted)",
                        textTransform: "uppercase",
                        fontWeight: 600,
                        letterSpacing: "0.08em"
                    }}
                    >
                    Document
                    </p>
                    <p
                    style={{
                        margin: "4px 0 0",
                        fontSize: 13,
                        color: "var(--text)"
                    }}
                    >
                    Scientific Article
                    </p>
                </div>
                </div>
            </div>
            </div>
        </div>
        <div
            className="plan-card premium-card"
            style={{
            padding: 0,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            border: "1px solid rgba(59, 131, 246, 0.51)"
            }}
        >
            <div
            style={{
                width: "100%",
                height: 120,
                background: "linear-gradient(135deg, #3b82f6 0%, #1e40af 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                overflow: "hidden"
            }}
            >
            <div
                style={{
                position: "absolute",
                inset: 0,
                background:
                    "radial-gradient(circle at 70% 40%, rgba(255,255,255,0.15) 0%, transparent 60%)"
                }}
            />
            <i
                data-lucide="book-open-text"
                style={{
                width: 80,
                height: 80,
                color: "rgba(255,255,255,0.9)",
                position: "relative",
                zIndex: 1
                }}
            />
            </div>
            <div
            style={{
                padding: 32,
                display: "flex",
                flexDirection: "column",
                flex: 1
            }}
            >
            <div
                style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                marginBottom: 6
                }}
            >
                <div
                style={{
                    width: 44,
                    height: 44,
                    borderRadius: 10,
                    background: "rgba(79,142,247,0.12)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}
                >
                <i
                    data-lucide="flask-conical"
                    style={{ width: 22, height: 22, color: "#3b82f6" }}
                />
                </div>
                <div>
                <p
                    style={{
                    margin: 0,
                    fontSize: 12,
                    color: "#3b82f6",
                    fontWeight: 600,
                    textTransform: "uppercase",
                    letterSpacing: "0.08em"
                    }}
                >
                    Water Chemistry
                </p>
                <p style={{ margin: 0, fontSize: 13, color: "var(--muted)" }}>
                    Skimming conditions
                </p>
                </div>
            </div>
            <h3
                className="serif"
                style={{
                fontSize: 22,
                fontWeight: 400,
                margin: "0 0 12px",
                lineHeight: "1.3",
                color: "var(--text)"
                }}
            >
                From unstable to stable foam
            </h3>
            <p
                style={{
                color: "var(--muted)",
                fontSize: 14,
                lineHeight: "1.7",
                margin: "0 0 20px",
                textAlign: "left"
                }}
            >
                Foam fractionation and skimming systems are widely used in recirculat-
                ing aquaculture systems (RAS) to remove dissolved and particulate organic
                matter. However, the operational dynamics of skimmers in large commercial
                RAS installations remain poorly quantified, and transitions between unstable
                and stable foam regimes are rarely documented using system-scale data
            </p>
            <div
                style={{
                borderTop: "1px solid rgba(162,89,255,0.2)",
                paddingTop: 16,
                marginTop: "auto"
                }}
            >
                <div style={{ display: "flex", gap: 12 }}>
                <div>
                    <p
                    style={{
                        margin: 0,
                        fontSize: 12,
                        color: "var(--muted)",
                        textTransform: "uppercase",
                        fontWeight: 600,
                        letterSpacing: "0.08em"
                    }}
                    >
                    Sope
                    </p>
                    <p
                    style={{
                        margin: "4px 0 0",
                        fontSize: 13,
                        color: "var(--text)"
                    }}
                    >
                    Water Quality
                    </p>
                </div>
                <div
                    style={{
                    borderLeft: "1px solid rgba(255,255,255,0.1)",
                    paddingLeft: 12
                    }}
                >
                    <p
                    style={{
                        margin: 0,
                        fontSize: 12,
                        color: "var(--muted)",
                        textTransform: "uppercase",
                        fontWeight: 600,
                        letterSpacing: "0.08em"
                    }}
                    >
                    Document
                    </p>
                    <p
                    style={{
                        margin: "4px 0 0",
                        fontSize: 13,
                        color: "var(--text)"
                    }}
                    >
                    Scientific Article
                    </p>
                </div>
                </div>
            </div>
            </div>
        </div>
        <div
            className="plan-card"
            style={{
            padding: 0,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            background:
                "linear-gradient(160deg, rgba(255, 173, 96, 0.08) 0%, rgba(255, 173, 96, 0.02) 100%), linear-gradient(var(--surface), var(--surface))",
            border: "1px solid rgba(255, 173, 96, 0.25)"
            }}
        >
            <div
            style={{
                width: "100%",
                height: 120,
                background: "linear-gradient(135deg, #FFAD60 0%, #f59e0b 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                overflow: "hidden"
            }}
            >
            <div
                style={{
                position: "absolute",
                inset: 0,
                background:
                    "radial-gradient(circle at 50% 50%, rgba(255,255,255,0.15) 0%, transparent 60%)"
                }}
            />
            <i
                data-lucide="clipboard-plus"
                style={{
                width: 80,
                height: 80,
                color: "rgba(255,255,255,0.9)",
                position: "relative",
                zIndex: 1
                }}
            />
            </div>
            <div
            style={{
                padding: 32,
                display: "flex",
                flexDirection: "column",
                flex: 1
            }}
            >
            <div
                style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                marginBottom: 6
                }}
            >
                <div
                style={{
                    width: 44,
                    height: 44,
                    borderRadius: 10,
                    background: "rgba(255,173,96,0.15)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}
                >
                <i
                    data-lucide="fish"
                    style={{ width: 22, height: 22, color: "#FFAD60" }}
                />
                </div>
                <div>
                <p
                    style={{
                    margin: 0,
                    fontSize: 12,
                    color: "#FFAD60",
                    fontWeight: 600,
                    textTransform: "uppercase",
                    letterSpacing: "0.08em"
                    }}
                >
                    Production
                </p>
                <p style={{ margin: 0, fontSize: 13, color: "var(--muted)" }}>
                    Optimizing production 
                </p>
                </div>
            </div>
            <h3
                className="serif"
                style={{
                fontSize: 22,
                fontWeight: 400,
                margin: "0 0 12px",
                lineHeight: "1.3",
                color: "var(--text)"
                }}
            >
                Example of CV report
            </h3>
            <p
                style={{
                color: "var(--muted)",
                fontSize: 14,
                lineHeight: "1.7",
                margin: "0 0 20px",
                textAlign: "left"
                }}
            >
                Create automatic detailed reports about the batches in production.
                Compile and summarize the entire conditions that the batch has been 
                exposed to, in what we called CV-report. 
            </p>
            <img src={aqw_biomass} 
            alt="Seamless Integration" 
            loading="lazy" 
            style={{ width: "50%", height: "50%", objectFit: "contain", marginBottom: "25px" }} />
            <div
                style={{
                borderTop: "1px solid rgba(158,211,205,0.2)",
                paddingTop: 16,
                marginTop: "auto"
                }}
            >
                <div style={{ display: "flex", gap: 12 }}>
                <div>
                    <p
                    style={{
                        margin: 0,
                        fontSize: 12,
                        color: "var(--muted)",
                        textTransform: "uppercase",
                        fontWeight: 600,
                        letterSpacing: "0.08em"
                    }}
                    >
                    Scope
                    </p>
                    <p
                    style={{
                        margin: "4px 0 0",
                        fontSize: 13,
                        color: "var(--text)"
                    }}
                    >
                    Optimization
                    </p>
                </div>
                <div
                    style={{
                    borderLeft: "1px solid rgba(255,255,255,0.1)",
                    paddingLeft: 12
                    }}
                >
                    <p
                    style={{
                        margin: 0,
                        fontSize: 12,
                        color: "var(--muted)",
                        textTransform: "uppercase",
                        fontWeight: 600,
                        letterSpacing: "0.08em"
                    }}
                    >
                    Document
                    </p>
                    <p
                    style={{
                        margin: "4px 0 0",
                        fontSize: 13,
                        color: "var(--text)"
                    }}
                    >
                    Technical report
                    </p>
                </div>
                </div>
            </div>
            </div>
        </div>
        </div>
    </div>
    </section>


  );
};

export default CaseStudiesComponent;
